import styled from 'styled-components';
import { OpenInNewIcon, palette } from '@dev/ee-components';

export const ContentWrapper = styled.div`
    width: 100%
`;

export const OpenInNewIconBlue = styled(OpenInNewIcon as any)`
    fill: ${palette.indigo[6]};
`;

export const IconWrapper = styled.div`
    display: flex;
    margin-left: 4px;
    margin-right: 8px;
    svg {
        fill: ${palette.gray[4]};
    }
`; 